export {default as ModuleOne } from './1'
export {default as ModuleTwo } from './2'
export {default as ModuleThree } from './3'
export { default as ModuleFour } from './4'
export {default as ModuleFive } from './5'
export {default as ModuleSix } from './6'
export {default as ModuleSeven } from './7'
export {default as ModuleEleven } from './11'
export {default as ModuleTwelve } from './12'
export {default as ModuleThirteen } from './13'
export {default as ModuleEighteen } from './18'
export {default as ModuleNineteen } from './19'
export { default as ModuleTwentySeven } from './27'
export { default as ModuleTwentyEight } from './28'
export { default as ModuleTwentyNine } from './29'
export { default as ModuleThirty } from './30'
export { default as ModuleThirtyOne } from './31'
export { default as ModuleThirtyTwo } from './32'
export { default as ModuleThirtyThree } from './33'
export { default as ModuleThirtyFour } from './34'
export { default as ModuleThirtyFive } from './35'




// WEBPACK FOOTER //
// ./src/components/Modules/index.js